"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZuoraCreateSubscriptionPayloadSchema = void 0;
exports.ZuoraCreateSubscriptionPayloadSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        messageId: {
            type: 'string',
        },
        eventDate: {
            type: 'string',
            minLength: 1,
        },
        subscriptionRatePlanId: {
            type: 'string',
            minLength: 1,
        },
        currencyIsoCode: {
            type: 'string',
            minLength: 1,
        },
        serviceContractId: {
            type: 'string',
            minLength: 1,
        },
        sonosCustomerId: {
            type: 'string',
            minLength: 1,
        },
        subscriptionSequenceSetId: {
            type: 'string',
            minLength: 1,
        },
        subscriptionCommunicationProfileId: {
            type: 'string',
            minLength: 1,
        },
        billingCountry: {
            type: 'string',
            minLength: 1,
        },
        billingCity: {
            type: 'string',
            minLength: 1,
        },
        billingPostalCode: {
            type: 'string',
            minLength: 1,
        },
        billingStateCode: {
            type: 'string',
        },
        subscriptionLegalEntity: {
            type: 'string',
            minLength: 1,
        },
        billingStreetLine1: {
            type: 'string',
        },
        billingStreetLine2: {
            type: 'string',
        },
        subscriptionOrderDateOverride: {
            type: 'string',
        },
        subscriptionTerm: {
            type: 'string',
            minLength: 1,
        },
        zuoraPaymentMethodId: {
            type: 'string',
            minLength: 1,
        },
        zuoraPaymentGateway: {
            type: 'string',
            minLength: 1,
        },
        email: {
            type: 'string',
        },
        firstName: {
            type: 'string',
            minLength: 1,
        },
        lastName: {
            type: 'string',
            minLength: 1,
        },
        eventType: {
            type: 'string',
        },
        invoiceTemplateId: {
            type: 'string',
        },
    },
    required: [
        'eventDate',
        'subscriptionRatePlanId',
        'currencyIsoCode',
        'sonosCustomerId',
        'subscriptionSequenceSetId',
        'subscriptionCommunicationProfileId',
        'billingCountry',
        'billingCity',
        'billingPostalCode',
        'subscriptionLegalEntity',
        'subscriptionTerm',
        'firstName',
        'lastName',
        'serviceContractId',
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,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